export default "__VITE_ASSET__CAvV4THt__"